export default __webpack_public_path__ + "static/media/ImgC3.49cdcc51.png";